export default function requestDocumentDownload() {
    const $triggers = document.querySelectorAll('[data-request-document-download]');
    $triggers.forEach($trigger => {
        $trigger.addEventListener('click', event => {
            event.preventDefault();

            let productId = event.target.dataset.productId;
            let documentId = event.target.dataset.documentId;
            let dlfileentry_type_name = event.target.dataset.dlfileentryTypeName;
            let groupId = event.target.dataset.groupId;
            let uuid = event.target.dataset.uuid;

            if (event.target.tagName !== 'a') {
                const $link = event.target.closest('a');
                productId = $link.dataset.productId;
                documentId = $link.dataset.documentId;
                dlfileentry_type_name = $link.dataset.dlfileentryTypeName;
                groupId = $link.dataset.groupId;
                uuid = $link.dataset.uuid;
            }

            document.dispatchEvent(
                new CustomEvent('requests-document-download', {
                    detail: {
                        productId,
                        documentId,
                        dlfileentry_type_name,
                        groupId,
                        uuid,
                    },
                })
            );
        });
    });
}
